import * as React from 'react';
import { GlobalAdministrationRoute } from '../../routes';
import { routes } from '../../routes/routes';
import AdminList from './AdminList/AdminList';
import { GeneralHint } from './Configuration/GeneralHint/GeneralHint';
import LocalizationPage from './Configuration/Localization';
import { ProductHint } from './Configuration/ProductHint/ProductHint';
import { Substrate } from './Configuration/Substrate/Substrate';
import Documents from './Documents/Documents';
import { DocumentsUpload } from './Documents/DocumentsUpload';
import { DynamicExport } from './Export/DynamicExport/DynamicExport';
import ProductCatalogPriceImport from './Import/ProductCatalog/ProductCatalogPriceImport';
import { MailingList } from './MailingList/MailingList';

export function AdminRoutes(): JSX.Element {
  return (
    <>
      <GlobalAdministrationRoute exact path={routes.adminRoute} component={AdminList} />
      <GlobalAdministrationRoute exact path={routes.GeneralHint()} component={GeneralHint} />
      <GlobalAdministrationRoute exact path={routes.Substrate()} component={Substrate} />
      <GlobalAdministrationRoute exact path={routes.ProductHint()} component={ProductHint} />
      <GlobalAdministrationRoute exact path={routes.MailingList()} component={MailingList} />
      <GlobalAdministrationRoute exact path={routes.AdminConfigurationLocalization()} component={LocalizationPage} />
      <GlobalAdministrationRoute exact path={routes.DocumentsManagement()} component={Documents} />
      <GlobalAdministrationRoute exact path={routes.DocumentsUpload()} component={DocumentsUpload} />
      <GlobalAdministrationRoute exact path={routes.DynamicExport()} component={DynamicExport} />
      <GlobalAdministrationRoute exact path={routes.Import()} component={ProductCatalogPriceImport} />
    </>
  );
}
